import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from "react";
const GenerationContext = createContext(undefined);
export const GenerationProvider = ({ children, }) => {
    const [isGeneratingText, setIsGeneratingText] = useState(false);
    return (_jsx(GenerationContext.Provider, { value: { isGeneratingText, setIsGeneratingText }, children: children }));
};
export const useGeneration = () => {
    const context = useContext(GenerationContext);
    if (!context) {
        throw new Error("useGeneration must be used within GenerationProvider");
    }
    return context;
};
